/*
 * @Author: Teemo Ding
 * @Date: 2021-09-14 17:21:56
 * @LastEditTime: 2022-06-10 14:21:37
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/List/config.tsx
 */
import { DropDown, Form, Menu, MenuItem, Select } from '@/src/components/Antd';
import { Icon } from '@/src/tools/icon';
import {
  EnumStatus,
  MissingPageRedirectType,
  MissingPageType,
} from '@/src/types/common/domain';
import React, { useMemo } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import StatusTag from '../Components/StatusTag';
import css from './css.module.less';
const { Item } = Form;

const missingPageTypeOption = (missingPageType, { getI18n }) => [
  ...(missingPageType !== MissingPageType.NoAvailableContentVersion
    ? [
        {
          label: '404 Page',
          value: MissingPageRedirectType.Page404,
        },
      ]
    : []),
  ...(missingPageType == MissingPageType.NoAvailableContentVersion
    ? [
        {
          label: 'Maintenance Page',
          value: MissingPageRedirectType.MaintenancePage,
        },
      ]
    : []),
  {
    label: 'Other Page',
    value: MissingPageRedirectType.OtherPage,
  },
];

export enum ActionType {
  Edit = 'Edit',
  Connect = 'Connect',
  Delete = 'Delete',
}

const TableDefultValue = ({ value }: any) => {
  const name = {
    [MissingPageType.NoAvailableContentVersion]: 'No Available Content Version',
    [MissingPageType.PageDeleted]: 'Page Deleted',
    [MissingPageType.PageExpired]: 'Page Expired',
    [MissingPageType.ProductDeleted]: 'Product Deleted',
    [MissingPageType.UrlNotFound]: 'Url Not Found',
  };
  return name[value];
};

const RenderSelect = ({
  value,
  onChange,
  missingPageOnChange,
  index,
  edit,
  missingPageType,
}: // linkListData,
any) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const handleMissingPageOnCahnge = (selectValue) => {
    //
    if (selectValue == MissingPageRedirectType.OtherPage) {
      missingPageOnChange(selectValue, value, index);
    } else {
      onChange({ ...value, missingPageRedirectType: selectValue });
    }
  };

  const selectValue = useMemo(() => {
    if (value.missingPageRedirectType == MissingPageRedirectType.OtherPage) {
      const linkModule = value.linkModule;
      return linkModule.label || '';
    } else {
      return value.missingPageRedirectType;
    }
  }, [value]);

  return edit ? (
    <Select
      value={selectValue}
      onChange={handleMissingPageOnCahnge}
      className={css.missingPageRedirectType}
      optionsList={missingPageTypeOption(missingPageType, { getI18n })}
    />
  ) : (
    <div>{selectValue}</div>
  );
};

export const columns = (handleActionFun, disabled, { getI18n }) => [
  {
    title: getI18n('salesChannelDomainAndStatus.list.domainName'),
    dataIndex: 'domain',
    key: 'domain',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 384,
  },
  {
    title: getI18n('general.status'),
    dataIndex: 'status',
    key: 'status',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 192,
    childGenerate: (text, record) => {
      return <StatusTag status={text} />;
    },
  },
  {
    title: getI18n('general.remarks'),
    dataIndex: 'remarks',
    key: 'remarks',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 384,
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'action',
    key: 'action',
    align: 'center',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 128,
    childGenerate: (text, record, index) => {
      const overlayActionNoDraftList = overlayActionNoDraft(
        record.defaultDomain,
        record.uuid,
        record.status,
        handleActionFun,
        { getI18n },
      );
      return (
        !(record.defaultDomain && record.status == EnumStatus.Connected) && (
          <DropDown
            overlay={overlay(overlayActionNoDraftList, disabled)}
            getPopupContainer={() => document.body}
            placement='bottomRight'
            trigger={['click']}>
            <div className={css.moreActions}>
              <Icon type='iconMore'></Icon>
            </div>
          </DropDown>
        )
      );
    },
  },
];
const overlay = (data, disabled) => (
  <Menu className={css.overlay}>
    {data.map((item) => (
      <MenuItem
        disabled={disabled}
        className={`${css.menuItem} ${item.name.toLowerCase()}`}
        key={item.key}
        onClick={() => item.function()}>
        {item.name}
      </MenuItem>
    ))}
  </Menu>
);

export const redirectColumns = (
  fields,
  missingPageOnChange,
  edit,
  form,
  getI18n,
  // linkListData,
) => [
  {
    title: getI18n('salesChannelDomainAndStatus.list.missingPageType'),
    dataIndex: 'missingPageType',
    key: 'missingPageType',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 448,
    childGenerate: (text, record, index) => {
      return (
        <Item
          className={css.missingPageType}
          name={[fields[index].name, 'missingPageType']}>
          <TableDefultValue />
        </Item>
      );
    },
  },
  {
    title: getI18n('salesChannelDomainAndStatus.list.redirectto'),
    dataIndex: 'missingPageRedirectType',
    key: 'missingPageRedirectType',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 640,
    childGenerate: (text, record, index) => {
      return (
        <Item className={css.missingPageType} name={[fields[index].name]}>
          <RenderSelect
            missingPageOnChange={missingPageOnChange}
            // linkListData={linkListData}
            edit={edit}
            missingPageType={form.getFieldValue([
              'missingPageRedirections',
              fields[index].name,
              'missingPageType',
            ])}
            index={index}
          />
        </Item>
      );
    },
  },
];

const overlayActionNoDraft = (
  defaultDomain,
  uuid,
  status,
  actionFun,
  { getI18n },
) => [
  ...(!(status == EnumStatus.Disconnected && defaultDomain)
    ? [
        {
          name: getI18n('salesChannelDomainAndStatus.list.viewDetails'),
          key: 1,
          function: () => actionFun(uuid, ActionType.Edit),
        },
      ]
    : []),
  ...(status == EnumStatus.Verified || status == EnumStatus.Disconnected
    ? [
        {
          name: getI18n('salesChannelDomainAndStatus.list.connect'),
          key: 2,
          function: () => actionFun(uuid, ActionType.Connect),
        },
      ]
    : []),
  ,
  ...(!(status == EnumStatus.Disconnected && defaultDomain)
    ? [
        {
          name: getI18n('general.remove'),
          key: 3,
          function: () => actionFun(uuid, ActionType.Delete),
        },
      ]
    : []),
];
